import React from "react";
import GridLayout from "./Layouts/Grid";
import CarouselLayout from "./Layouts/Carousel";
import "./BlogArticlesList.scss";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";

const layouts = {
    "grid": GridLayout,
    "grid_reverse": GridLayout,
    "carousel": CarouselLayout
};

export const BlogArticlesList = ({ initialArticles, settings }) => {
    const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
    let Layout = layouts[settings.section.layout_type] || GridLayout;

    const { blocks } = settings;
    if (isMobile) {
        Layout = layouts[settings.section.layout_type_mobile] || GridLayout;
    }

    if (!initialArticles){
        initialArticles = [];
        if (blocks){
            blocks.forEach((block) => {
                if (block.article) {
                    initialArticles.push(block.article);
                }
            });
        }
    }

    return (
        <div
            className={`relative`}
            style={{
                paddingTop: `${settings.section.padding_top}px`,
                paddingBottom: `${settings.section.padding_bottom}px`,
            }}
        >
            <div className="relative w-full h-full justify-end items-end">
                <Layout initialArticles={initialArticles} settings={settings}/>
            </div>
        </div>
    );
};
